import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LogonComponent } from './startup/logon/logon.component';
import { AuthGuard } from './core/services/auth-guard.service';
import { PasswordResetComponent } from './startup/password-reset/password-reset.component';
import { ProfileInformationComponent } from './profile-information/profile-information.component';
import { ChangeUserComponent } from './core/components/change-user/change-user.component';
import { SsologoutComponent } from './startup/ssologout/ssologout.component';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'search', pathMatch: 'full' },
      { path: 'profile-information', component: ProfileInformationComponent },
      {
        path: 'search',
        loadChildren: () => import('./search/search.module').then((m) => m.SearchModule)
      },
      {
        path: 'door-to-door',
        loadChildren: () =>
          import('./get-me-there/get-me-there.module').then((m) => m.GetMeThereModule)
      },
      {
        path: 'itinerary',
        loadChildren: () => import('./itinerary/itinerary.module').then((m) => m.ItineraryModule)
      },
      {
        path: 'my-bookings',
        loadChildren: () =>
          import('./my-bookings/my-bookings.module').then((m) => m.MyBookingsModule)
      },
      {
        path: 'results',
        loadChildren: () => import('./results/results.module').then((m) => m.ResultsModule)
      },
      {
        path: 'live-rail',
        loadChildren: () =>
          import('./search/components/rail-live/rail-live-search.module').then(
            (m) => m.LiveRailSearchModule
          )
      }
    ]
  },
  { path: 'reset-password', component: PasswordResetComponent },
  { path: 'logon', component: LogonComponent },
  { path: 'sso-logout', component: SsologoutComponent },
  {
    path: 'changeuser',
    component: ChangeUserComponent
  },
  { path: '**', redirectTo: 'search', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
